import React from 'react';

// Importing individual components
import Main from '../Components/MainSection/Main';
import HeadingSection from '../Components/Headings/Heading';
import CarDetails from '../Components/CarsDetails/Car';
import Banner from '../Components/MainBanner/Banner';
import BlogSlider from '../Components/BlogCardsHome/BlogSlider';

const Screenfirst = () => {
    return (
        <>
            {/* Main Content of Screen */}
            <Main />
            <HeadingSection />
            <CarDetails />
            {/* <BlogSlider/> */}
            <Banner />
        </>
    );
};

export default Screenfirst;
